














































import { defineComponent, reactive, computed, ref, watch, getCurrentInstance } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import userConfigHandler from '@/renderer/components/user/compositions/userConfigHandler';
import store from '@/renderer/store/index';
import phonePrefixOptions from '@/renderer/scripts/utils/phonePrefix';
import { phonePrefixFilter } from '@/renderer/common/phoneUtils';
import userValidator, { validatePhoneNumber, validateSMS } from '../compositions/userValidator';
export default defineComponent({
  props: {
    isSaveDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const formData = reactive({
      countryCode: store.getters.userBaseInfo.countryCode,
      phoneNumber: '',
      code: '',
    });
    const phoneMaxLen = computed(() => (formData.countryCode === '+86' ? 11 : 20));
    const SECOND_COUNT = 60;
    const seconds = ref(SECOND_COUNT);
    const sended = ref(false);
    let timer: number | undefined;
    const smsText = computed(() =>
      sended.value
        ? i18n_t('{slot1}S后重发', {
            slot1: seconds.value,
          })
        : i18n_t('获取验证码'),
    );
    const { sendSMS, updatePhoneNumber } = userConfigHandler();
    const { rules } = userValidator(formData);
    const phoneRule = {
      phoneNumber: rules.phoneNumber,
    };
    const phoneIsCorrect = ref(false);
    const smsIsCorrect = ref(false);

    /**
     * 发送验证码按钮置灰：
     * 1.手机号校验失败
     * 2.已经发送过正在倒计时中
     */
    const sendSmsDisabled = computed(() => !phoneIsCorrect.value || sended.value);
    // 初始化重置为初值countryCode
    // store.commit('setLogin', { countryCode: formData.countryCode });
    const methods = {
      phonePrefixFilter,
      // 手机前缀改变
      handleCodeChange(val: any) {
        // store.commit('setLogin', { countryCode: val });
        if (formData.phoneNumber && formData.phoneNumber.length > phoneMaxLen.value) {
          formData.phoneNumber = formData.phoneNumber.substring(0, phoneMaxLen.value);
        }
      },
      startCountSeconds() {
        sended.value = true;
        timer = window.setInterval(() => {
          if (seconds.value === 0) {
            this.resetSeconds();
            return;
          }
          seconds.value--;
        }, 1000);
      },
      // 重置倒计时
      resetSeconds() {
        if (timer) {
          window.clearInterval(timer);
          timer = undefined;
        }
        sended.value = false;
        seconds.value = SECOND_COUNT;
      },
      async sendSMSFn() {
        this.startCountSeconds();
        const { countryCode, phoneNumber } = formData;
        const isCancelCountSecond = await sendSMS(countryCode, phoneNumber);
        if (isCancelCountSecond) {
          this.resetSeconds();
        }
      },
      async onSubmit() {
        const { countryCode, phoneNumber, code } = formData;
        const updateResult = await updatePhoneNumber(countryCode, phoneNumber, code);
        if (updateResult) {
          context.emit('close');
        }
      },
    };
    watch(formData, () => {
      phoneIsCorrect.value = validatePhoneNumber(formData.countryCode, `${formData.phoneNumber}`);
      smsIsCorrect.value = validateSMS(`${formData.code}`);
      const allCorrect = phoneIsCorrect.value && formData.code && smsIsCorrect.value;
      // 保存按钮的disabled在父组件里控制 这里需要给父组件更新下状态
      context.emit('update:isSaveDisabled', allCorrect);
    });
    return {
      phoneRule,
      phonePrefixOptions,
      formData,
      sendSmsDisabled,
      phoneIsCorrect,
      smsText,
      phoneMaxLen,
      ...methods,
    };
  },
});
